import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { Observable } from 'rxjs';
import {
    PacksActionsTypes, PacksActions,
    ActionPacksMakeOrder,
    ActionPacksMakeOrderSuccess, ActionPacksError,
    ActionPacksGetPaymentData,
    ActionPacksPaymentInitiated,
    ActionPacksPaymentError,
    ActionPacksPaymentDataError,
    ActionPacksShowOrder,
    ActionPacksRestoreOrderPayment
} from '@app/certificates/packs/packs.reducer';
import { tap, switchMap, map } from 'rxjs/operators';
import { Injectable, inject } from '@angular/core';
import { PackService } from '@app/certificates/packs/pack.service';
import {
    ISpringResponseBody,
    IPaymentDataPostResponse
} from '@app/shared/interfaces/response-interfaces';
import { InfoService } from '@app/core/info/info.service';
import { Router } from '@angular/router';
import { IOrder } from '../history/history';

@Injectable()
export class PackEffects {

    private actions$ = inject(Actions<PacksActions>)
    private router = inject(Router)
    private packService = inject(PackService)
    public info = inject(InfoService)


    makeOrder$ = createEffect(() => {
        return this.actions$
            .pipe(ofType(PacksActionsTypes.MAKE_ORDER),
                switchMap((action: ActionPacksMakeOrder) => {
                    return this.packService.createOrder(action.payload);
                }),
                map((response: ISpringResponseBody) => {
                    if (response.status === 200) {
                        return new ActionPacksMakeOrderSuccess(response.data);
                    } else {
                        this.info.error(response.message);
                        return new ActionPacksError({ response });
                    }
                })
            );
    }, { dispatch: true })

    /**
     * Обръща се към сървис за получаване на данни за плащане и при успех
     * започва да прави проверки за променен статус на плащането
     */


    
    initiatePayment$ = createEffect(() => {
        let order: IOrder;
        return this.actions$
            .pipe(ofType(PacksActionsTypes.GET_PAYMENT_DATA),
                switchMap((action: ActionPacksGetPaymentData) => {
                    order = action.order;

                    return this.packService.getPaymentData(action.order.orderId, action.order.price);
                }),
                map((response: IPaymentDataPostResponse) => {
                    // TODO Check error handling of payment link with backend so we can have good one
                    if (response.status === 200 && response.data !== 'ERROR') {
                        return new ActionPacksPaymentInitiated(order.orderCode);
                    }
                })
            );
    }, { dispatch: true })


    actionPacksPaymentError$ = createEffect(() => {
        return this.actions$
            .pipe(ofType(PacksActionsTypes.PAYMENT_ERROR),
                tap((action: ActionPacksPaymentError) => {
                    this.info.endWait();
                    this.info.error(action.response.message);
                })
            );
    }, { dispatch: false })


    actionPacksPaymentSuccess$ = createEffect(() => {
        return this.actions$
            .pipe(ofType(PacksActionsTypes.PAYMENT_SUCCESS),
                tap(() => {
                    this.info.endWait();
                    this.info.success('packsTexts.cardPaymentSuccess');
                })
            );
    }, { dispatch: false })

    actionPacksPaymentFailed$ = createEffect(() => {
        return this.actions$.pipe(ofType(PacksActionsTypes.PAYMENT_FAILED),
            tap(() => {
                this.info.endWait();
                this.info.error('packsTexts.cardPaymentFailed');
            })
        );
    }, { dispatch: false })

    actionPacksShowOrder$ = createEffect(() => {
        return this.actions$
            .pipe(ofType(PacksActionsTypes.SHOW_ORDER),
                tap((action: ActionPacksShowOrder) => {
                    this.router.navigate(
                        ['./certificates/packs'],
                        {
                            queryParams: { order: action.order.orderCode }
                        }
                    );
                })
            );
    }, { dispatch: false })

    actionPacksRestoreOrderPayment$ = createEffect(() => {
        return this.actions$
            .pipe(ofType(PacksActionsTypes.PAYMENT_RESTORED),
                tap((action: ActionPacksRestoreOrderPayment) => {
                    this.router.navigate(
                        ['./manage/packs']
                    );
                })
            );
    }, { dispatch: false })


    actionPacksPaymentDataError$ = createEffect(() => {
        return this.actions$
            .pipe(ofType(PacksActionsTypes.PAYMENT_DATA_ERROR),
                tap(() => {
                    this.info.endWait();
                    this.info.error('packsTexts.cardPaymentFailed');
                })
            );
    }, { dispatch: false })

}
